/**
 * Formats a given date string into a localized date format (YYYY.MM.DD or MM/DD/YYYY)
 * based on the user's selected language.
 *
 * @param {string} dateString - The date string to format.
 * @returns {string} The formatted date string.
 */
export const formatDate = (dateString: string, language: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(language === "hu" ? "hu-HU" : "en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
